module.exports = __webpack_public_path__ + "static/media/gray_checked_circle.446ffe39.svg";